import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Navigate, useParams } from "react-router-dom";
import Wrapper from "../../components/Wrapper";
import InnerNav from "../../components/InnerNav";
import { FiSave } from "react-icons/fi";

const CompanypaymentdetailEdit = () => {
  const [bank, setBank] = useState("");
  const [bankBranch, setBankBranch] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [paybill, setPaybill] = useState("");
  const [tillnumber, setTillnumber] = useState("");
  const [mpesaaccountnumber, setMpesaaccountnumber] = useState("");
  const [redirect, setRedirect] = useState(false);
  const ref = useRef < HTMLInputElement > null;

  let { id } = useParams();
  useEffect(() => {
    (async () => {
      const { data } = await axios.get(`companypaymentdetail/${id}`);
      setBank(data.bank);
      setBankBranch(data.bank_branch);
      setAccountNumber(data.account_number);
      setPaybill(data.pay_bill);
      setTillnumber(data.till_number);
      setMpesaaccountnumber(data.mpesa_account_number);
    })();
  }, [id]);
  const submit = async (e) => {
    e.preventDefault();
    const { data } = await axios.put(`companypaymentdetail/${id}`, {
      bank,
      bank_branch: bankBranch,
      account_number: accountNumber,
      pay_bill: paybill,
      till_number: tillnumber,
      mpesa_account_number: mpesaaccountnumber,
    });
    console.log(data);
    setRedirect(true);
  };

  if (redirect) {
    return <Navigate to={"/companypaymentdetail"} />;
  }
  return (
    <Wrapper pageTitle={"Edit Companypaymentdetail"}>
      <InnerNav
        createLink={"/companypaymentdetailCreate"}
        listLink={"/companypaymentdetail"}
      />
      <form onSubmit={submit}>
        <div className="px-4 py-3 mb-8 bg-white rounded-lg shadow-md dark:bg-gray-800">
          <label className="block text-sm">
            <span className="text-gray-700 dark:text-gray-400">Bank </span>
            <input
              className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
              placeholder="Bank"
              value={bank}
              onChange={(e) => setBank(e.target.value)}
            />
          </label>

          <label className="block text-sm">
            <span className="text-gray-700 dark:text-gray-400">
              Bank Branch{" "}
            </span>
            <input
              className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
              placeholder="Bank Branch"
              value={bankBranch}
              onChange={(e) => setBankBranch(e.target.value)}
            />
          </label>

          <label className="block text-sm">
            <span className="text-gray-700 dark:text-gray-400">
              Account Number{" "}
            </span>
            <input
              className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
              placeholder="Account Number"
              value={accountNumber}
              onChange={(e) => setAccountNumber(e.target.value)}
            />
          </label>

          <label className="block text-sm">
            <span className="text-gray-700 dark:text-gray-400">Paybill </span>
            <input
              className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
              placeholder="Paybill"
              value={paybill}
              onChange={(e) => setPaybill(e.target.value)}
            />
          </label>

          <label className="block text-sm">
            <span className="text-gray-700 dark:text-gray-400">
              Till Number{" "}
            </span>
            <input
              className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
              placeholder="Till Number"
              value={tillnumber}
              onChange={(e) => setTillnumber(e.target.value)}
            />
          </label>

          <label className="block text-sm">
            <span className="text-gray-700 dark:text-gray-400">
              Mpesa Account Number{" "}
            </span>
            <input
              className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
              placeholder="Mpesa Account Number"
              value={mpesaaccountnumber}
              onChange={(e) => setMpesaaccountnumber(e.target.value)}
            />
          </label>

          <div className="flex mt-6 text-sm">
            <label className="flex items-center dark:text-gray-400">
              <button
                className="flex items-center justify-between px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-blue-600 border border-transparent rounded-lg active:bg-white hover:bg-blue-400 focus:outline-none focus:shadow-outline-purple"
                onClick={submit}
              >
                {" "}
                <FiSave /> <span className="ml-3">Save</span>{" "}
              </button>
            </label>
          </div>
        </div>
      </form>
    </Wrapper>
  );
};
export default CompanypaymentdetailEdit;
